import React, { PureComponent } from "react"
import PropTypes from "prop-types"

import styles from "./Step.css"

class Step extends PureComponent {
  static propTypes = {
    showDivider: PropTypes.bool,
    showDividerMidStep: PropTypes.bool,
    step: PropTypes.shape({
      passed: PropTypes.bool.isRequired,
      displayName: PropTypes.string.isRequired,
      additionalInformation: PropTypes.object,
    }).isRequired,
  }
  static defaultProps = {
    showDivider: false,
    showDividerMidStep: false,
  }

  renderMiddleStep() {
    return (
      <div className={styles.middleCircle} />
    )
  }

  render() {
    const { showDivider, showDividerMidStep, step } = this.props
    return (
      <div className={[styles.root, step.passed ? styles.passed : ""].join(" ")}>
        {showDivider && (
          <div className={[styles.divider, showDividerMidStep ? styles.dividerHalf : ""].join(" ")}>
            {showDividerMidStep && this.renderMiddleStep()}
          </div>
        )}
        <div className={styles.step}>
          <div className={styles.circle}>
            <i className="zmdi zmdi-check block"></i>
          </div>
          <div className={styles.description}>
            <span className={[styles.name, step.additionalInformation ? styles.withInformation : ""].join(" ")}>
              {step.displayName}
            </span>
            {step.additionalInformation}
          </div>
        </div>
      </div>
    )
  }
}

export default Step



// WEBPACK FOOTER //
// ./src/views/Parcel/components/DeliveryProgress/components/Step/Step.js